module.exports = __webpack_public_path__ + "static/media/pizza-slice.089fc6fc.svg";